// Request bodies for the Rails account endpoints (showman-api), which own
// signup (POST /web/users) and profile edits (PATCH /web/users/:id).

const ADDRESS_FIELDS = ['address_line1', 'address_line2', 'city', 'state', 'zip', 'country']

function pickAddress (address) {
  const picked = {}
  ADDRESS_FIELDS.forEach(field => {
    if (address && address[field] !== undefined) picked[field] = address[field]
  })
  return picked
}

// The signup form's fields, for POST /web/users. Rails takes the uid and email
// from the Firebase token, not the body.
export function signupBody (userData) {
  return {
    user: {
      first_name: userData.first_name,
      last_name: userData.last_name,
      farm_name: userData.farm_name,
      phone_number: userData.phone_number,
      agree_to_terms: true,
      address: pickAddress(userData.address)
    }
  }
}

// The fields My Profile edits, for PATCH /web/users/:id. The rest of the user
// object (role, stripe_customer_id, …) is not sent.
export function profileBody (user) {
  return {
    first_name: user.first_name,
    last_name: user.last_name,
    farm_name: user.farm_name,
    phone_number: user.phone_number,
    address: pickAddress(user.address)
  }
}

// The signup screens show a failure's errorMessage.
export function signupError (message) {
  const error = new Error(message)
  error.errorMessage = message
  return error
}
